(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avera-details-back"] && !Shopify.designMode) return;
  try {
    
function initializeBackGuide(scope) { scope.querySelectorAll('[data-back-guide]:not([data-ready])').forEach(root => { root.dataset.ready='true'; const tabs=[...root.querySelectorAll('[role="tab"]')]; const panels=[...root.querySelectorAll('[role="tabpanel"]')]; const activate=i=>{tabs.forEach((tab,n)=>{tab.classList.toggle('is-active',n===i);tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;});}; tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n);tabs[n].focus();});});});} initializeBackGuide(document);document.addEventListener('shopify:section:load',e=>initializeBackGuide(e.target));

function initializeAveraFaq(scope) {
  scope.querySelectorAll('.avera-faq-list details:not([data-avera-faq-ready])').forEach((details) => {
    details.setAttribute('data-avera-faq-ready', '');
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      if (animation) { animation.cancel(); animation = null; }
      details.removeAttribute('data-closing');
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expanded;
        return;
      }
      details.open = true;
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (!expanded) details.setAttribute('data-closing', '');
      const currentAnimation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      animation = currentAnimation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        details.open = expanded;
        details.removeAttribute('data-closing');
        animation = null;
        currentAnimation.cancel();
      };
    });
  });
}
initializeAveraFaq(document);
document.addEventListener('shopify:section:load', (event) => initializeAveraFaq(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avera-details-insoles"] && !Shopify.designMode) return;
  try {
    

function initializeAveraFaq(scope) {
  scope.querySelectorAll('.avera-faq-list details:not([data-avera-faq-ready])').forEach((details) => {
    details.setAttribute('data-avera-faq-ready', '');
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      if (animation) { animation.cancel(); animation = null; }
      details.removeAttribute('data-closing');
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expanded;
        return;
      }
      details.open = true;
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (!expanded) details.setAttribute('data-closing', '');
      const currentAnimation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      animation = currentAnimation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        details.open = expanded;
        details.removeAttribute('data-closing');
        animation = null;
        currentAnimation.cancel();
      };
    });
  });
}
initializeAveraFaq(document);
document.addEventListener('shopify:section:load', (event) => initializeAveraFaq(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avera-details-knees"] && !Shopify.designMode) return;
  try {
    
function initializeKneeGuide(scope) { scope.querySelectorAll('[data-knee-guide]:not([data-ready])').forEach(root => { root.dataset.ready='true'; const tabs=[...root.querySelectorAll('[role="tab"]')]; const panels=[...root.querySelectorAll('[role="tabpanel"]')]; const activate=i=>{tabs.forEach((tab,n)=>{tab.classList.toggle('is-active',n===i);tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;});}; tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n);tabs[n].focus();});});});} initializeKneeGuide(document);document.addEventListener('shopify:section:load',e=>initializeKneeGuide(e.target));

function initializeAveraFaq(scope) {
  scope.querySelectorAll('.avera-faq-list details:not([data-avera-faq-ready])').forEach((details) => {
    details.setAttribute('data-avera-faq-ready', '');
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      if (animation) { animation.cancel(); animation = null; }
      details.removeAttribute('data-closing');
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expanded;
        return;
      }
      details.open = true;
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (!expanded) details.setAttribute('data-closing', '');
      const currentAnimation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      animation = currentAnimation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        details.open = expanded;
        details.removeAttribute('data-closing');
        animation = null;
        currentAnimation.cancel();
      };
    });
  });
}
initializeAveraFaq(document);
document.addEventListener('shopify:section:load', (event) => initializeAveraFaq(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avera-details-neck"] && !Shopify.designMode) return;
  try {
    
function initializePillowGuide(scope) { scope.querySelectorAll('[data-pillow-guide]:not([data-ready])').forEach(root => { root.dataset.ready='true'; const tabs=[...root.querySelectorAll('[role="tab"]')]; const panels=[...root.querySelectorAll('[role="tabpanel"]')]; const activate=i=>{tabs.forEach((tab,n)=>{tab.classList.toggle('is-active',n===i);tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;});}; tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n);tabs[n].focus();});});});} initializePillowGuide(document);document.addEventListener('shopify:section:load',e=>initializePillowGuide(e.target));

function initializeAveraFaq(scope) {
  scope.querySelectorAll('.avera-faq-list details:not([data-avera-faq-ready])').forEach((details) => {
    details.setAttribute('data-avera-faq-ready', '');
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      if (animation) { animation.cancel(); animation = null; }
      details.removeAttribute('data-closing');
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expanded;
        return;
      }
      details.open = true;
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (!expanded) details.setAttribute('data-closing', '');
      const currentAnimation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      animation = currentAnimation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        details.open = expanded;
        details.removeAttribute('data-closing');
        animation = null;
        currentAnimation.cancel();
      };
    });
  });
}
initializeAveraFaq(document);
document.addEventListener('shopify:section:load', (event) => initializeAveraFaq(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avera-product-conversion-stack"] && !Shopify.designMode) return;
  try {
    

function initializeAveraFaq(scope) {
  scope.querySelectorAll('.avera-faq-list details:not([data-avera-faq-ready])').forEach((details) => {
    details.setAttribute('data-avera-faq-ready', '');
    const summary = details.querySelector('summary');
    let animation = null;
    let expanded = details.open;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      if (animation) { animation.cancel(); animation = null; }
      details.removeAttribute('data-closing');
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        details.open = expanded;
        return;
      }
      details.open = true;
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      if (!expanded) details.setAttribute('data-closing', '');
      const currentAnimation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      animation = currentAnimation;
      currentAnimation.onfinish = () => {
        if (animation !== currentAnimation) return;
        details.open = expanded;
        details.removeAttribute('data-closing');
        animation = null;
        currentAnimation.cancel();
      };
    });
  });
}
initializeAveraFaq(document);
document.addEventListener('shopify:section:load', (event) => initializeAveraFaq(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
